/**
 * @generated SignedSource<<50918fbf517a7e5e4c9692306548a47b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobTestsTreeCountsQuery$variables = {
  locator: string;
};
export type JobTestsTreeCountsQuery$data = {
  readonly testOccurrences: {
    readonly " $fragmentSpreads": FragmentRefs<"OverviewTabFragment">;
  } | null | undefined;
};
export type JobTestsTreeCountsQuery = {
  response: JobTestsTreeCountsQuery$data;
  variables: JobTestsTreeCountsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "locator",
    "variableName": "locator"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "JobTestsTreeCountsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TestOccurrences",
        "kind": "LinkedField",
        "name": "testOccurrences",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OverviewTabFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JobTestsTreeCountsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TestOccurrences",
        "kind": "LinkedField",
        "name": "testOccurrences",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TestCounters",
            "kind": "LinkedField",
            "name": "testCounters",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ignored",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "success",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "muted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "all",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "200af22b10f77e3e66e1919a1283749f",
    "id": null,
    "metadata": {},
    "name": "JobTestsTreeCountsQuery",
    "operationKind": "query",
    "text": "query JobTestsTreeCountsQuery(\n  $locator: String!\n) {\n  testOccurrences(locator: $locator) {\n    ...OverviewTabFragment\n  }\n}\n\nfragment OverviewTabFragment on TestOccurrences {\n  testCounters {\n    ...TestsPreviewPanelCountersFragment\n  }\n}\n\nfragment TestsPreviewPanelCountersFragment on TestCounters {\n  ignored\n  success\n  muted\n  all\n}\n"
  }
};
})();

(node as any).hash = "39e910aa7555b7a3d42dff12bf1434a8";

export default node;
